// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const create = function () {
  return {
    content_type: "muji"
  }
}
const descriptor = {}

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "PurchId",
      label: "平台采购单号",
      sortable: true,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "AXPurchId",
      label: "AX采购单号",
      sortable: true,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "dataAreaId",
      label: "公司",
      sortable: true,
      thStyle: {
        width: "4rem"
      }
    },
    {
      key: "PubCompanyName",
      label: "公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      type: "short"
    },

    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true,
      thStyle: {
        width: "110px"
      }
    },
    {
      key: "is_complated",
      label: "完成状态",
      sortable: true,
      thStyle: {
        width: "80px"
      },
      type: "state",
      context: ["未完成", "已完成"]
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "LineNumber",
      label: "行号",
      sortable: true
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },

    {
      key: "PurchQty",
      label: "数量",
      sortable: true,
      type: "just_integer",
      _precise: 6
    },
    {
      key: "PurchUnit",
      label: "单位",
      sortable: true
    },
    {
      key: "PurchPrice",
      label: "价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "LineAmount",
      label: "净额",
      sortable: true,
      type: "number",
      _precise: 2
    },

    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "RemainPurchPhysical",
      label: "剩余交货数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "RemainSalesFinancial",
      label: "未开票数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "OverDeliveryPct",
      label: "超交",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "UnderDeliveryPct",
      label: "欠交",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "DeliveryDate",
      label: "交货日期",
      sortable: true,
      type: "date"
    }
  ],
  item_fields: [
    {
      key: "LineNumber",
      label: "行号",
      sortable: true
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "dataAreaId",
      label: "公司",
      sortable: true
    },
    {
      key: "PubCompanyName",
      label: "公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      type: "short"
    },
    {
      key: "PurchQty",
      label: "数量",
      sortable: true,
      type: "just_integer",
      _precise: 6
    },
    {
      key: "PurchUnit",
      label: "单位",
      sortable: true
    },
    {
      key: "PurchPrice",
      label: "价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "LineAmount",
      label: "净额",
      sortable: true,
      type: "number",
      _precise: 2
    },

    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "RemainPurchPhysical",
      label: "剩余交货数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "RemainSalesFinancial",
      label: "未开票数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "OverDeliveryPct",
      label: "超交",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "UnderDeliveryPct",
      label: "欠交",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "DeliveryDate",
      label: "交货日期",
      sortable: true,
      type: "date"
    }
  ],
  delivery_plan_fileds: [
    {
      key: "PurchId",
      label: "采购单号",
      sortable: true,
      thStyle: {
        width: "6rem"
      }
    },

    {
      key: "DeliveryQty",
      label: "计划数量",
      editable: true,
      type: "number",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "DeliveryDate",
      label: "交期",
      editable: true,
      type: "date",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "Remark",
      label: "备注",
      editable: true,
      type: "textarea"
    }
  ],
  sf_default: [

    {
      key: "ForecastSalesId",
      label: "预测订单编码",
      sortable: true
    },
    {
      key: "PubCompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "ModelId",
      label: "预测模型"
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型"
    },
    {
      key: "qty",
      label: "数量",
      type: "number",
      _precise: 6
    },

    {
      key: "delivery_date",
      label: "装运日期",
      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",
      type: "number"
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "is_cancel",
      label: "取消",
      sortable: true,
      type: "boolean"
    }
  ],
  purch_return_fields: [
    {
      key: "id",
      label: "编号",
      sortable: true
    },
    // {
    //   key: "dataAreaId",
    //   label: "销售公司",
    //   sortable: true
    // },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "local_PurchId",
      label: "平台采购单号",
      sortable: true,
      thStyle: {
        width: "8rem"
      },
      type: "short"
    },
    {
      key: "PurchId",
      label: "AX采购单号",
      thStyle: {
        width: "8rem"
      },
      type: "short"
    },
    {
      key: "LineNumber",
      label: "行号",
      sortable: true
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      },
      type: "short"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      },
      type: "short"
    },
    {
      key: "SalesId",
      label: "平台销售订单编号",
      sortable: true
    },
    {
      key: "TEC_CustAccount",
      label: "客户账户",
      sortable: true
    },
    {
      key: "Cust_SEI_Name",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      },
      type: "short"
    },
    {
      key: "AccountNum",
      label: "供应商账户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true
    },
    {
      key: "PurchStatus",
      label: "行状态",
      sortable: true
    },
    {
      key: "DeliveryDate",
      label: "交货日期",
      sortable: true,
      type: "date"
    },
    {
      key: "create_at",
      label: "开单日期",
      type: "date"
    },
    {
      key: "username",
      label: "开单人"
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "PurchQty",
      label: "采购数量",
      type: "number",
      _precise: 6
    },
    {
      key: "DeliveryQty",
      label: "交货数量",
      type: "number",
      _precise: 6
    },
    {
      key: "RemainPurchPhysical",
      label: "剩余交货量",
      type: "number",
      _precise: 6
    },
    {
      key: "PurchFinancial",
      label: "开票数量",
      type: "number",
      _precise: 6
    },
    {
      key: "RemainPurchFinancial",
      label: "未开票数量",
      type: "number",
      _precise: 6
    },
    {
      key: "PurchPrice",
      label: "单位价格",
      type: "number",
      _precise: 6
    },
    {
      key: "price_wotax",
      label: "本币不含税",
      type: "number",
      _precise: 6
    },
    {
      key: "CurrencyCode",
      label: "币种"
    },
    {
      key: "PurchUnit",
      label: "单位"
    },

    {
      key: "TaxItemGroup",
      label: "销售税(物料)组"
    },
    {
      key: "UnderDeliveryPct",
      label: "欠交",
      type: "number"
    },
    {
      key: "OverDeliveryPct",
      label: "超交",
      type: "number"
    }
  ],
  plan_fields: [
    {
      key: "PurchId",
      label: "采购单号",
      sortable: true,
      thStyle: {
        width: "6rem"
      }
    },

    {
      key: "DeliveryQty",
      label: "计划数量",
      type: "number",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "DeliveryDate",
      label: "交期",
      type: "date",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "Remark",
      label: "备注",
      type: "textarea"
    }
  ],
  production_capacity_fields: [
    {
      key: "set_date",
      label: "日期",
      sortable: true,
      type: "date",
      thStyle: {
        width: "120px"
      }
    },
    {
      key: "AccountNum",
      label: "供应商账户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true
    },
    {
      key: "ProductionCapacity",
      label: "剩余产能（天）",
      sortable: true,
      type: "number"
    },

    {
      key: "description",
      label: "备注",
      sortable: true
    }
    // {
    //   key: "create_by",
    //   label: "创建人",
    //   formatter: (value, key, item) => {
    //     return item.create_by_username;
    //   }
    // },
  ],
  inventsum_fields: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },

    {
      key: "ItemId",
      label: "物料编号",
      sortable: true,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "TEC_CustAccount",
      label: "客户账户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "客户名称",
      sortable: true
    },
    {
      key: "OnOrder",
      label: "在单",
      sortable: true,
      type: "number"
    },
    {
      key: "Ordered",
      label: "已订购",
      sortable: true,
      type: "number"
    },
    {
      key: "AvailOrdered",
      label: "可用合计",
      sortable: true,
      type: "number"
    },
    {
      key: "AvailPhysical",
      label: "实际库存",
      sortable: true,
      type: "number"
    },
    {
      key: "PhysicalValue",
      label: "实际成本额",
      sortable: true,
      type: "number"
    }
    // {
    //   key: "batch_date",
    //   label: "导入日期",
    //   type: "date",
    //   sortable: true
    // },
  ],
  sfd_fields: [
    {
      key: "id",
      label: "派发编号",
      sortable: true
    },
    {
      key: "ForecastSalesId",
      label: "预测单编号",
      sortable: true
    },
    {
      key: "seq",
      label: "预测明细行号",
      sortable: true
    },
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "11rem"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "ModelId",
      label: "预测模型",
      editable: true
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型",
      type: "textarea"
    },
    {
      key: "qty",
      label: "数量",
      type: "number"
    },
    {
      key: "delivery_date",
      label: "装运日期",
      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",
      type: "number"
    },

    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true
    },
    {
      key: "create_at",
      label: "创建时间",
      type: "datetime"
    },
    {
      key: "is_cancel",
      label: "预测是否取消",
      type: "boolean"
    },
    {
      key: "is_complated",
      label: "完成状态",
      sortable: true,
      thStyle: {
        width: "80px"
      },
      type: "state",
      context: ["未完成", "已完成"]
    }
  ],
  sfd_delivery_plan_fields: [
    {
      key: "ForecasetDispatchId",
      label: "派发编号",
      sortable: true
    },
    {
      key: "AccountNumName",
      label: "供应商名称",
      sortable: true
    },
    {
      key: "DeliveryQty",
      label: "计划数量",
      editable: true,
      type: "number"
    },
    {
      key: "DeliveryDate",
      label: "交期",
      editable: true,
      type: "date"
    },
    {
      key: "Remark",
      label: "备注",
      editable: true,
      type: "textarea"
    }
  ],
  order_fields: [
    {
      key: "ConsultQuoteNum",
      label: "询价申请编号",
      sortable: true,
      thStyle: { width: "120px" }
    },
    {
      key: "Description",
      label: "描述",
      sortable: true,
      width: "150px",
      thStyle: { width: "12rem" }
    },
    { key: "create_by_username", label: "创建人", sortable: true },
    { key: "send_email_date", label: "创建时间", sortable: true, type: "date" },
    { key: "is_approved", label: "已确认", type: "boolean", otherkey: "isRefused" },
    { key: "is_commited", label: "已提交", type: "boolean" },
  ],
  consult_handle_fields: [
    // { key: 'ConsultQuoteNum', label: '询价申请编号', sortable: true, thStyle: { width: "120px" } },
    {
      key: "LineNum",
      label: "行号",
      sortable: true,
      thStyle: { width: "80px" }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true,
      thStyle: { width: "120px" }
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: { width: "14rem" }
    },
    {
      key: "TEC_SpecType",
      label: "规格型号",
      sortable: true,
      thStyle: { width: "10rem" }
    },
    {
      key: "FromQty",
      label: "起始数量",
      sortable: true,
      type: "number",
      thStyle: { width: "120px" }
    },
    {
      key: "ToQty",
      label: "结束数量",
      sortable: true,
      type: "number",
      thStyle: { width: "120px" }
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true,
      thStyle: { width: "8rem" }
    },
    {
      key: 'UnfoldSize', label: '展开尺寸', sortable: true,
      width: "120px", thStyle: { width: "10rem" }
    },
    {
      key: "DeliveryAddress",
      label: "交货地址",
      sortable: true,
      width: "150px",
      thStyle: { width: "10rem" }
    },
    {
      key: "DeliveryMode",
      label: "运输方式",
      sortable: true,
      width: "150px",
      thStyle: { width: "10rem" }
    },
    {
      key: "TradeMode",
      label: "贸易方式",
      sortable: true,
      width: "150px",
      thStyle: { width: "10rem" }
    },
    {
      key: "Description",
      label: "描述",
      sortable: true,
      width: "150px",
      thStyle: { width: "12rem" }
    },
    {
      key: "Accessory",
      label: "附件",
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    }
  ],
  consult_handle_vend_fields: [
    {
      key: "LineNum",
      label: "申请明细行号",
      sortable: true,
      thStyle: { width: "120px" }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true,
      thStyle: { width: "120px" }
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: { width: "14rem" }
    },
    {
      key: "FromQty",
      label: "起始数量",
      sortable: true,
      type: "number",
      thStyle: { width: "120px" }
    },
    {
      key: "ToQty",
      label: "结束数量",
      sortable: true,
      type: "number",
      thStyle: { width: "120px" }
    },
    {
      key: "Price",
      label: "报价",
      sortable: true,
      editable: true,
      type: "number",
      thStyle: { width: "120px" }
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true,
      thStyle: { width: "4rem" }
    },
    { key: "InclTax", label: "价格是否含税" },
    { key: "TaxGroup", label: "税组" },
    {
      key: "Transport",
      label: "其他费用",
      editable: true,
      type: "number",
      thStyle: { width: "100px" }
    },
    {
      key: "DayOutQty",
      label: "每日产量",
      editable: true,
      type: "number",
      thStyle: { width: "100px" }
    },
    { key: 'Description', label: '备注', editable: true, type: "textarea" },
    {
      key: "Accessory",
      label: "附件",
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    }
  ],
  consult_handle_other_cost_fields: [
    {
      key: "OtherCostType",
      label: "其他费用类别",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "OtherCost",
      label: "其他费用",
      sortable: true,
      type: "number",
      editable: true,
      required: true,
      width: "200px",
      thStyle: {
        width: "10rem"
      }
    }
  ]
}

const dataForm = {
  id: "",
  PurchId: "",
  LineNumber: "",
  OrderAccount: "",
  PurchQty: "",
  DeliveryQty: "",
  DeliveryDate: "",
  Remark: ""
}
const dataDeliveryForm = {
  id: "", //主键
  ForecasetDispatchId: 0, //采购单号
  DeliveryQty: 0, //交货数量
  DeliveryDate: "", //交期
  Remark: "", //备注
  is_deleted: 0
}

const rules = {}
const methods = {
  async saveVendPurchDeliveryData(_list) {
    const biz_data = new biz_data_helper.base_entity_helper(
      "save_get_vend_purchase_order_line",
      {},
      {}
    )
    let _actions = []
    _.each(_list, t => {
      _actions.push(biz_data.execAction({ params: t }).action({}))
    })

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  }
}
export { dataDeliveryForm, dataForm, fields, methods };

